import React from 'react';
import PropTypes from 'prop-types';

import { isBlank } from 'helpers/string_helpers';
import NewTaskForm from './new_task_form';
import EditTaskForm from './edit_task_form';
import FollowUpTaskForm from './follow_up_task_form';
import { Alert } from 'react-bootstrap-5';

class Tasks extends React.Component {
  static propTypes = {
    associateToCallList: PropTypes.bool,
    callListId: PropTypes.number,
    callListsAccess: PropTypes.bool.isRequired,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    editingTask: PropTypes.object.isRequired,
    followUp: PropTypes.bool.isRequired,
    followUpTask: PropTypes.object.isRequired,
    record: PropTypes.object.isRequired,
    showErrorPane: PropTypes.bool.isRequired,
    taskErrors: PropTypes.array,
    onAddAssociation: PropTypes.func.isRequired,
    onErrorPaneDismiss: PropTypes.func,
    onFollowUp: PropTypes.func.isRequired,
    onFollowUpTaskChange: PropTypes.func.isRequired,
    onRemoveAssociation: PropTypes.func.isRequired,
    onRemoveTaskListAssociation: PropTypes.func.isRequired,
    onTaskChange: PropTypes.func.isRequired,
    onToggleCallList: PropTypes.func.isRequired
  };

  render() {
    return (
      <>
        {this.renderActivity()}
        {this.renderFollowUpActivity()}
      </>
    );
  }

  renderActivity = () => {
    const {
      callListsAccess,
      record,
      databaseMembers,
      callListId,
      editingTask,
      followUp,
      onAddAssociation,
      onFollowUp,
      onRemoveAssociation,
      onRemoveTaskListAssociation,
      onTaskChange
    } = this.props;

    if (isBlank(callListId)) {
      return (
        <div className="preview-overlay-activity px-6 py-4">
          <div className="fw-semibold mb-4">Log Activity</div>
          {this.renderErrorPane()}
          <NewTaskForm
            callListsAccess={callListsAccess}
            canFollowUp
            databaseMembers={databaseMembers}
            followUp={followUp}
            isCompleted
            person={record}
            task={editingTask}
            onAddAssociation={onAddAssociation}
            onRemoveAssociation={onRemoveAssociation}
            onRemoveTaskListAssociation={onRemoveTaskListAssociation}
            onTaskChange={onTaskChange}
            onToggleFollowUp={onFollowUp}
          />
        </div>
      );
    } else {
      return (
        <div className="preview-overlay-activity px-6 py-4">
          <div className="fw-semibold mb-4">Current Task</div>
          <EditTaskForm
            callListsAccess={callListsAccess}
            canFollowUp
            followUp={followUp}
            person={record}
            task={editingTask}
            onAddAssociation={onAddAssociation}
            onRemoveAssociation={onRemoveAssociation}
            onRemoveTaskListAssociation={onRemoveTaskListAssociation}
            onTaskChange={onTaskChange}
            onToggleFollowUp={onFollowUp}
          />
        </div>
      );
    }
  };

  renderErrorPane() {
    const { taskErrors, onErrorPaneDismiss, showErrorPane } = this.props;
    if (taskErrors == null) return;
    return (
      <Alert dismissible show={showErrorPane} variant="danger" onClose={onErrorPaneDismiss}>
        <strong>Unable to save Task</strong>
        <ul>
          {taskErrors.map((error, index) => <li key={index}>{error}</li>)}
        </ul>
      </Alert>
    );
  }

  renderFollowUpActivity = () => {
    const {
      associateToCallList,
      callListId,
      followUp,
      followUpTask,
      databaseMembers,
      currentUser,
      onFollowUpTaskChange,
      onToggleCallList
    } = this.props;

    if (followUp) {
      return (
        <>
          <hr/>
          <div className="preview-overlay-followup px-6 py-4">
            <div className="fw-semibold mb-4">Follow Up</div>
            <FollowUpTaskForm
              associateToCallList={associateToCallList}
              callListId={callListId}
              databaseMembers={databaseMembers}
              defaultTaskAssignee={databaseMembers.find(member => member.id === currentUser.id)}
              followUpTask={followUpTask}
              onTaskChange={onFollowUpTaskChange}
              onToggleCallList={onToggleCallList}
            />
          </div>
        </>
      );
    }
  }
}

export default Tasks;
